import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../Helpers";
import {deserializeMedicalBilling, MedicalBilling} from "../../MedicalBilling";
import {Cron} from "helpers/forms/Cron";

type ProgramComponentMedicalBillingScheduleMode = "interval" | "cron";

interface ProgramComponentMedicalBilling extends DeserializedRecord {
  medicalBilling: MedicalBilling,
  assignDelayInDays: number,
  intervalInDays: number,
  assignOnStart: boolean,
  scheduleMode: ProgramComponentMedicalBillingScheduleMode,
  cron: Cron,
  cronText: string
}

interface ProgramComponentMedicalBillingData extends JSONAPIRecord {
  relationships: {
    medical_billing: JSONAPISingleRelationship
  }
}

const deserializeProgramComponentMedicalBilling: Deserializer<ProgramComponentMedicalBilling, ProgramComponentMedicalBillingData> = (data, included) => {
  const medicalBilling = deserializeSingleRelationship<MedicalBilling>(data.relationships.medical_billing, included, deserializeMedicalBilling);

  return {
    medicalBilling,
    cronText: data.attributes.cron,
    ...deserializeItem(data)
  };
};

export {
  ProgramComponentMedicalBilling, ProgramComponentMedicalBillingScheduleMode, deserializeProgramComponentMedicalBilling
};
